import i18n from 'services/base/i18n';

export default {
  name: () => i18n.pgettext(
    'Pages|Manage Plans|Plan Firewall|Billing Schedule',
    'Select Billing Cycle'
  ),
};
